import { validateEmail, CheckPassword } from '../utilities/utility';
import { openSignInModal } from '../utilities/helper';

$(function() {
  const signInClass = $('.signIn-btn');
  const checkoutSignInClass = $('.checkout-signIn-btn');

  function positionHeader() {
    const headerHeight =
      $('.nav-marketing').outerHeight() + $('.nav-header').outerHeight();
    $('.signIn-dropdown').css('top', headerHeight);
  }
  positionHeader();
  $(window).on('resize', positionHeader);
  // Fix for mobile view colorbox
  const cboxOptions = {
    maxWidthMd: '379px',
    maxWidthSm: 'auto'
  };

  let loginErrorval = $('#loginError').val();

  function openSignInDropdown() {
    window.localStorage.setItem('rightDropdown', 'open');
    $('.hide-signIn-dropdown').show();
    $('#j_username').focus();
    $('.getAccAlert').remove();
    $('.signIn-form').find('#account-email-deleted-error-msg').remove();
  }

  if (loginErrorval === 'true') {
    if (location.pathname.indexOf('checkout') === -1) {
      window.localStorage.setItem('rightDropdown', 'open');
      $('.hide-signIn-dropdown').show();
      $('#j_username').focus();
      $('#loginError').val('');
    }
  }

  function closeSignInDropdown() {
    $(this)
      .parents('.hide-signIn-dropdown')
      .hide();
  }

  function closeSignInModal() {
    $.fn.colorbox.close();
  }

  function validateEmailMsg(e) {
    const isEmailValid = validateEmail('.email');

    if (isEmailValid !== true) {
      e.preventDefault();
      $('.error-msg-text-email').show();
      $('.error-msg-text-pass').hide();
    } else {
      $('.error-msg-text-email').hide();
    }
  }

  function validatePassMsg(e) {
    const isPassValid = CheckPassword('.password');

    if (isPassValid !== true) {
      e.preventDefault();
      $('.error-msg-text-pass').show();
    } else {
      $('.error-msg-text-pass').hide();
    }
  }

  $('input.password:password').dPassword();
  $('#j_j_password').attr('placeholder', 'Password');
  $('#j_j_password').attr('disabled', false);
  $('#j_j_password').attr('maxlength', 20);

  function inputValueBlank() {
    const passVal = $('.password').val();
    const emailVal = $('.email').val();

    if (passVal === '' || emailVal === '') {
      $('.signIn-btn').attr('disabled', true);
    } else {
      $('.signIn-btn').attr('disabled', false);
    }
  }

  function validateCheckout(e) {
    let elements = document.getElementsByClassName('check-email');
    $.each(elements, function(i, inputVal) {
      inputVal.addEventListener('invalid', function(e) {
        e.preventDefault();
      });
    });
    chekoutValidateEmailMsg(e);
    chekoutValidatePassMsg(e);
  }

  function chekoutValidateEmailMsg(e) {
    const isEmailValid = validateEmail('.check-email');

    if (isEmailValid !== true) {
      e.preventDefault();
      $('.checkout-email-error').show();
      $('.checkout-password-error').hide();
    } else {
      $('.checkout-email-error').hide();
    }
  }

  function chekoutValidatePassMsg(e) {
    const isPassValid = CheckPassword('.check-password');

    if (isPassValid !== true) {
      e.preventDefault();
      $('.checkout .error-msg-text-pass').show();
    } else {
      $('.checkout .error-msg-text-pass').hide();
    }
  }

  function checkoutInputValueBlank() {
    const passVal = $('.checkout__login .check-password').val();
    const emailVal = $('.checkout__login .check-email').val();

    if (passVal === '' || emailVal === '') {
      $('.checkout-signIn-btn').attr('disabled', true);
    } else {
      $('.checkout-signIn-btn').attr('disabled', false);
    }
  }
  function onClickRemember() {
    if ($('.checkbox-toggle').hasClass('checked')) {
      $('.checkbox-reader').attr('aria-checked', 'false');
      $('.checkbox-toggle').removeClass('checked');
    } else {
      $('.checkbox-reader').attr('aria-checked', 'true');
      $('.checkbox-toggle').addClass('checked');
    }
  }
  $('.header-signin').on('click', openSignInDropdown);
  $('#signInModal .dropdown-menu h4 + .close').on('click', closeSignInModal);
  $('.hide-signIn-dropdown .dropdown-menu .close').on(
    'click',
    closeSignInDropdown
  );
  signInClass.on('click', validateEmailMsg);
  signInClass.on('click', validatePassMsg);
  $('.signIn-form input').on('keydown keyup', inputValueBlank);
  checkoutSignInClass.on('click', validateCheckout);
  $('.signIn-form.checkout input').on('input', checkoutInputValueBlank);
  $('#text-link-signin').on('click', openSignInModal);
  $('#j_j_password').attr('aria-label', 'password field');
  $('.checkbox-reader').on('click', onClickRemember);
  
  $("#j_password").show();
  $("#j_j_password").hide();
});
